// reducers/profileReport.js

import {
  GET_PROFILE_REPORT,
  GET_PROFILE_REPORT_CSV,
} from 'govbr.frontend.policy/constants/ActionTypes';

const initialState = {
  items: [],
  total: 0,
  page: 1,
  page_size: 30,
  loading: false,
  loaded: false,
};

export default function profile_report(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_PROFILE_REPORT}_PENDING`:
      return {
        ...state,
        loading: true,
      };

    case `${GET_PROFILE_REPORT}_SUCCESS`:
      return {
        ...state,
        ...action.result,
        loading: false,
        loaded: true,
      };

    case `${GET_PROFILE_REPORT}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
      };

    default:
      return state;
  }
}

export function profile_report_csv(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_PROFILE_REPORT_CSV}_PENDING`:
      return {
        ...state,
        loading: true,
      };

    case `${GET_PROFILE_REPORT_CSV}_SUCCESS`:
      return {
        ...state,
        ...action.result,
        loading: false,
        loaded: true,
      };

    case `${GET_PROFILE_REPORT_CSV}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
      };

    default:
      return state;
  }
}
